module.exports = __webpack_public_path__ + "img/project_12.a0226052.png";